module.exports = __webpack_public_path__ + "static/media/whatsapp-topo.c58d5bcf.svg";